import { tokens, withAlpha } from "../../../Common/designTokens";

// Layout and animation constants
export const INITIAL_ANIMATION_DELAY_MS = 10;
export const ROW_HEIGHT = "40px";
export const CELL_PADDING = "1px 8px";

// Shared column/branch sizing so RFQ visuals track protocol width tweaks
export const PROTOCOL_COLUMN_WIDTH = 150;
const RFQ_BRANCH_GAP = 76;
const BRANCH_WIDTH_VALUE = PROTOCOL_COLUMN_WIDTH; // was Math.max(PROTOCOL_COLUMN_WIDTH - RFQ_BRANCH_GAP, 40)
export const BRANCH_WIDTH = `${BRANCH_WIDTH_VALUE}px`;
export const BRANCH_WIDTH_PX = BRANCH_WIDTH_VALUE;

// RFQ Table positioning constants
export const RFQ_TABLE_MARGIN_TOP = "12px";
export const RFQ_TABLE_MARGIN_BOTTOM = "8px";

// Styling constants for the branch visualization
export const BEFORE_ELEMENT_BG_COLOR = withAlpha(tokens.colors.white,0.3);
export const BEFORE_ELEMENT_TRANSITION_DURATION = "0.3s ease-out";
export const TRANSLATION_Y_OFFSET = "-10px";

// Styling constants for the connector lines
export const CONNECTOR_WIDTH = "50.5px";
export const CONNECTOR_TRANSITION_DURATION = "0.4s ease-out";
export const CONNECTOR_TRANSITION_BASE_DELAY = 0.05; // seconds delay factor

// L-shape dimensions
export const L_SHAPE_CORNER_RADIUS = "6px";
export const L_SHAPE_BORDER_WIDTH = "1px";

// Table column definitions
export const RFQ_TABLE_COLUMNS = [
  { id: "venue", label: "Dealer", width: "120px", align: "left" },
  { id: "qty", label: "Qty", width: "80px", align: "right" },
  { id: "price", label: "Price", width: "80px", align: "right" },
//   { id: "quoteTTL", label: "Expiry", width: "80px", align: "center" },
  {
    id: "counterPrice",
    label: "Counter Price",
    width: "100px",
    align: "right",
  },
  {
    id: "acceptedPrice",
    label: "Traded Price",
    width: "100px",
    align: "right",
  },
  {
    id: "quoteExpiryDtTime",
    label: "Firm Execution Expiry(UTC)",
    width: "120px",
    align: "right",
  },
  { id: "status", label: "Status", width: "80px", align: "left" },
  { id: "action", label: "Action", width: "210px", align: "center" },
];

// Protocols that should use the Trumid RFQ rules. Extend this list over time.
export const ENHANCED_RFQ_PROTOCOLS = [
  "Trumid RFQ",
];
